import React from "react";
import "./product-card.css";
import { Link } from "react-router-dom";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

// const Product_card = (props) => {

const Product_card = ({ image, price, product_name, platforms = [] }) => {
  return (
    <>
      <section className="Product_card">
        <div className="img_div">
          <img className="prod_img" src={image} alt="product-image" />

          {/* <div className="sociallinks">
            <Link target="_blank" to={props.amazon_link}>
              <img
                className="icons"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/social-icons/Amazon_icon.png"
                }
              />
            </Link>
            <Link target="_blank" to={props.bigbasket_link}>
              <img
                className="icons"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/social-icons/Bigbasket_Logo.png"
                }
              />
            </Link>
            <Link target="_blank" to={props.blinkit_link}>
              <img
                className="icons"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/social-icons/blinkit.png"
                }
              />
            </Link>
            <Link target="_blank" to={props.flipcart_link}>
              <img
                className="icons"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/social-icons/flipkart.png"
                }
              />
            </Link>
          </div> */}

          <div className="sociallinks">
            {platforms
              ?.filter((item) => item?.product_url)
              ?.map((item, index) => (
                <a
                  key={index}
                  href={item.product_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="icons"
                    src={IDS?.IMG_URL + item?.Platform?.logo}
                    alt={item?.Platform?.name}
                  />
                </a>
              ))}
          </div>
        </div>

        <div className="overlaybg"></div>
        <div className="prd_details">
          <p className="modelno">₹{price}</p>
          <p className="prd_name">{product_name}</p>

          {/* <div className='btndiv'>
            <Link to={props.link}>
              <button className='viewbtn'>View Details</button>
            </Link>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Product_card;
